// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Switcher-module--bx--text-truncate--end--LgdaA";
export var bxTextTruncateFront = "Switcher-module--bx--text-truncate--front--fUZti";
export var nav = "Switcher-module--nav---VMi7";
export var open = "Switcher-module--open--LPCeO";
export var divider = "Switcher-module--divider--H1F9z";
export var link = "Switcher-module--link--IcjED";
export var linkDisabled = "Switcher-module--link--disabled--fiANH";